export default __webpack_public_path__ + "static/media/Alejandro.4c6b6eb1.jpg";